import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Chip,
  Typography,
  IconButton,
  Badge,
} from "@mui/material";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";
import DeleteIcon from '@mui/icons-material/Delete';

function MultiSelectChipsComponent({ businessUnits, onBusinessUnitSelected }) {
  // State to manage selected values and menu anchor
  //console.log("MultiSelectChips businessUnits : ",businessUnits);
  const [selectedValues, setSelectedValues] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);


  // Ref for the scrollable container
  const scrollRef = useRef(null);

// Sync selectedValues with parent when they change
useEffect(() => {
    onBusinessUnitSelected(selectedValues);
  }, [selectedValues, onBusinessUnitSelected]);


  // Reset component when options change
  useEffect(() => {
    setSelectedValues([]); // Clear selected values
    setAnchorEl(null);     // Close the menu
  }, [businessUnits]);
  
  // console.log("MultiSelectChips options : ",options);

  // Handle checkbox selection
  const handleCheckboxChange = (option) => {
    const isSelected = selectedValues.some(
      (item) => item.businessUnitId === option.businessUnitId
    );
    if (isSelected) {
      setSelectedValues(
        selectedValues.filter(
          (item) => item.businessUnitId !== option.businessUnitId
        )
      );
    } else {
      setSelectedValues([...selectedValues, option]);
    }
  };

  // Handle chip deletion
  const handleDeleteChip = (optionId) => {
    setSelectedValues(
      selectedValues.filter((item) => item.businessUnitId !== optionId)
    );
  };

  // Open menu
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close menu
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Scroll left
  const handleScrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft -= 100; // Scroll left by 100px
    }
  };

  // Scroll right
  const handleScrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft += 100; // Scroll right by 100px
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 2,
        p: 2,
      }}
    >
      {/* First Child: Button and Multi-Select Menu */}
      <Box>
        <Button
          variant="contained"
          color={selectedValues?.length > 0 ?"secondary" : "primary"}
          sx={{
            borderRadius: "50px",
          }}
          onClick={handleMenuOpen}
        >
          Select BusinessUnits
          {selectedValues?.length > 0 && <Badge badgeContent={selectedValues.length} color="warning" sx={{ml:2}}/>}
        </Button>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          PaperProps={{
            style: {
              maxHeight: 200,
              width: "400px",
            },
          }}
        >
          {businessUnits.map((option) => (
            <MenuItem
              key={option.id}
              onClick={() => handleCheckboxChange(option)}
              dense
              sx={{ whiteSpace: "nowrap" }}
            >
              <Checkbox
                edge="start"
                checked={selectedValues.some(
                  (item) => item.businessUnitId === option.businessUnitId
                )}
                onChange={() => handleCheckboxChange(option)}
              />
              {option.businessUnitId}-{option.businessUnitName}
            </MenuItem>
          ))}
        </Menu>
      </Box>

      {/* Second Child: Display Selected Chips in Row */}
      <Box sx={{ maxWidth: "800px" }}>
        {/* <Box
          sx={{
            display: 'flex',
            flexDirection: 'row', // Display chips in a row
            gap: 1,
            overflowX: 'auto', // Add horizontal scrolling if chips overflow
            pb: 1, // Padding bottom for spacing
          }}
        >
          {selectedValues.length > 0 ? (
            selectedValues.map((value) => (
              <Chip
                key={value.businessUnitId}
                label={value.businessUnitName}
                onDelete={() => handleDeleteChip(value.businessUnitId)}
                color="primary"
                variant="outlined"
              />
            ))
          ) : (
            <Typography>No BusinessUnit selected</Typography>
          )}
        </Box> */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {/* Left Scroll Button */}
          <IconButton onClick={handleScrollLeft} aria-label="scroll left">
            <ArrowLeft />
          </IconButton>

          {/* Scrollable Chips Container */}
          <Box
            ref={scrollRef}
            sx={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "row",
              gap: 1,
              overflowX: "auto",
              whiteSpace: "nowrap",
              scrollBehavior: "smooth", // Smooth scrolling effect
              "&::-webkit-scrollbar": {
                display: "none", // Hide default scrollbar (optional)
              },
            }}
          >
            {selectedValues.length > 0 ? (
              selectedValues.map((value) => (
                <Chip
                  key={value.businessUnitId}
                  label={value.businessUnitName}
                  onDelete={() => handleDeleteChip(value.businessUnitId)}
                  color="primary"
                  variant="outlined"
                  deleteIcon={<DeleteIcon color="secondary" sx={{"&:hover": { color: "warning" } }}/>}
                  sx={{ display: "inline-flex" }}
                />
              ))
            ) : (
              <Typography sx={{ display: "inline" }}>
                No values selected
              </Typography>
            )}
          </Box>

          {/* Right Scroll Button */}
          <IconButton onClick={handleScrollRight} aria-label="scroll right">
            <ArrowRight />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
}

export default MultiSelectChipsComponent;
